import axios from 'axios';

const useGetImportTemplate = () => {
  const getTemplate = async (resourceType) => {
    return await axios.get(`/idcards/import/${resourceType}Template`);
  };

  return {
    getTemplate,
  };
};

export default useGetImportTemplate;
